<template>
  <el-dialog
    append-to-body
    :title="Baslik"
    :visible="ModalOlayi"
    center
    width="70%">
    <a @click="$emit('ModalOlayi', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <el-form :model="data" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
      <input v-model="data.id" type="hidden"></input>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Ad Soyad" prop="AdSoyad">
            <el-input v-model="data.AdSoyad"></el-input>
          </el-form-item>
          <small v-if="data.id">Kullanıcı özel bilgilerini kullanıcı düzenleyebilir</small>
        </el-col>
        <el-col :span="data.span">
          <el-form-item label="Telefon" prop="Telefon">
            <el-input v-model="data.Telefon" v-mask="'### ### ## ##'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="data.span">
          <el-form-item label="Email" prop="Email">
            <el-input type="email" v-model="data.Email"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="data.id && !data.Yetkili">
          <el-form-item class="Tooltip" :label="$t('eYonetim.20.6')" prop="durum">
            <el-tooltip class="item" effect="dark"
                        content="Kullanıcı sistem kullanım durum (Admin hesapları etkilenmez)"
                        placement="top">
              <i class="el-icon-info text-primary cursor-pointer"></i>
            </el-tooltip>
            <el-switch v-model="data.durum"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-alert
        v-if="!data.id"
        title="KVKK Kuralları gereği şifre sistem tarafından üretilip kullanıcıya mail olarak iletilecektir."
        type="info"
        :closable="false"
      >
      </el-alert>


    </el-form>
    <hr v-if="data.id">
    <el-alert
      v-if="data.id"
      title="Güncelleme durumunda Kullanıcının aktif oturumu kapatılacaktır."
      type="warning"
      :closable="false"
    >
    </el-alert>

    <div slot="footer" class="dialog-footer">
      <el-button v-if="!lo" type="primary" size="medium" @click="Submit()" icon="el-icon-check">
        {{$t('eGenel.0')}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      ModalOlayi: Boolean,
      Baslik: String,
      data: {
        type: Object,
        require: true
      },
    },
    data() {
      return {
        lo: false,

        FormHata: {
          AdSoyad: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Email: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Telefon: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },

      }
    },
    methods: {
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.lo = true;
            if (this.data.id) {
              // DÜZENLE
              this.$store.dispatch("Put", {
                ...this.data,
                path: 'kullanici/' + this.data.id
              })
                .then(response => {
                  this.lo = false;
                  if (response.Durum == "OK") {
                    this.$emit("ModalOlayi", false);
                    this.$message.success(response.Mesaj);
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })

            } else {
              // EKLE
              this.$store.dispatch("Post", {...this.data, path: 'kullanici'})
                .then(response => {
                  this.lo = false;
                  if (response.Durum == "OK") {
                    this.$emit("ModalOlayi", false);
                    this.$message.success(response.Mesaj);
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            }
          }
        });

      }
    },
    created() {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Pack/Kulanici/FormModal.vue